import React from 'react'
import { FeaturesContextProvider } from '@cbgms/base/feature-flags'
import useSupportFeatures from './useSupportFeatures'

interface Props {
  children: React.ReactNode
}

const SupportFeaturesContextProvider = ({ children }: Props) => {
  const enabledSupportFeatures = useSupportFeatures()

  return <FeaturesContextProvider features={enabledSupportFeatures}>{children}</FeaturesContextProvider>
}

export default SupportFeaturesContextProvider
